import React, { useContext, useEffect, useState } from "react";
import styles from "./GenerateCertifiacte.module.css";
import CustomInput from "../CustomInput/CustomInput";
import upload from "../../assets/componentAssets/upload.png";
import FinalCertificate from "../FinalCertificate/FinalCertificate";
import CustomCheckBox from "../CustomCheckBox/CustomCheckBox";
import { Button, MenuItem, Select, TextField } from "@mui/material";
import CostEffectiveTable from "../CostEffectiveTable/CostEffectiveTable";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import UploadImage from "../UploadImage/UploadImage";
import axios from "axios";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { PatchApi, base_url, getApi } from "../../Utility/network";
import { useNavigate } from "react-router-dom";
import { consumptionEngText, consumptionGermText } from "../Pannel/Pannel";
function GenerateNeedCertificate({ show = false, setShow }) {
  const navigate = useNavigate();
  const { state: contextState, setState } = useContext(AppContext);
  const { stepLanguage, language } = contextState;
  const [fieldError, setFieldError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = useState();
  const [buildingImg, setBuildingImg] = useState([]);
  const [submitData, setSubmitData] = useState({
    serial_number: null,
    tableData: [],
  });

  const [prevData, setPrevData] = useState({});

  const [uploadIssures, setUploadIssures] = useState({
    issued_by_id: null,
  });
  const [issures, setIssures] = useState([]);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (image) {
      uploadImageApi();
    }
  }, [image]);

  const uploadImageApi = () => {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("type", 2);
    const axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    axios
      .patch(
        `${base_url}/energy_consumption/form/${contextState.form_id}/upload_building_photos/`,
        formData,
        axiosConfig
      )
      .then((response) => {
        setImage();
        getData();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getData = async () => {
    try {
      const response = await getApi(
        `/energy_consumption/form/${contextState.form_id}/`
      );
      setBuildingImg(response.data.data.building_images);
    } catch (error) {}
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubmitData((prev) => ({ ...prev, [name]: value }));
  };
  const handleData = (_data) => {
    setSubmitData((prev) => ({ ...prev, tableData: _data }));
  };
  const handleSubmit = async () => {
    if (fieldError) {
      return;
    }
    try {
      const postData = await PatchApi(`/energy_need/${contextState.needId}/`, {
        serial_number: submitData.serial_number,
        recommendations: submitData.tableData,

        issued_by_id: uploadIssures?.issued_by_id,
        certificate_status: 2,
      });
      if (postData.status === 200 || postData.status === 201) {
        // setState((prev) => ({ ...prev, page: prev.page + 1 }));
        const postEnergy = await getApi(
          `energy_need/${contextState.needId}/calculate_energy_consumption/`
        );
        if (postData.status === 200) {
          const generate_pdf = await getApi(
            `records/energy_need/${postEnergy?.data?.data?.id}/generate_energy_need_certificate/`
          );
          if (generate_pdf.status === 200 || generate_pdf.status === 201) {
            setState((prev) => ({
              ...prev,
              pdfId: postEnergy?.data?.data?.id,
            }));
            if (postData.data.data.payment_status == 2) {
              navigate(
                `/energy-certificate/${contextState.needId}/${postEnergy?.data?.data?.id}`
              );
            } else {
              setShow(false);
            }
          }
        }
      }
    } catch (error) {}
  };
  const getIssures = async () => {
    try {
      const response = await getApi(`/auth/certificate_issue_users`);
      setIssures(response?.data?.data);
    } catch (error) {}
  };
  useEffect(() => {
    getIssures();
  }, []);
  const handleChangeINput = (e) => {
    const { name, value } = e.target;
    setUploadIssures({
      ...uploadIssures,
      [name]: value,
    });
  };
  useEffect(() => {
    if (prevData) {
      setSubmitData({
        serial_number: prevData?.serial_number,
        tableData: prevData?.recommendations,
      });
      setBuildingImg(prevData?.building_images);
      setUploadIssures({ issued_by_id: prevData?.issued_by?.id });
    }
  }, [prevData]);
  const getPrevData = async (id) => {
    if (!id) {
      return;
    }
    try {
      const responseData = await getApi(`/energy_need/${id}/`);
      setPrevData(responseData.data.data);
    } catch (error) {}
  };
  useEffect(() => {
    getPrevData(contextState.needId);
  }, [contextState.needId]);
  return (
    <div className={styles.con}>
      <Dialog
        fullWidth={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl" // You can use 'xs', 'sm', 'md', 'lg', 'xl' for different widths
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <p className={styles.name}>
            {" "}
            {language == "de"
              ? consumptionGermText?.serial_no
              : consumptionEngText?.serial_no}
          </p>
          <TextField
            // name={field.name}
            size="small"
            style={{ width: "100%" }}
            value={submitData.serial_number}
            name="serial_number"
            onChange={(e) => handleChange(e)}
          />
          <p className={styles.name}>
            {" "}
            {language == "de"
              ? consumptionGermText?.cert_issue
              : consumptionEngText?.cert_issue}
          </p>
          <Select
            sx={{ width: "100%" }}
            size="small"
            value={uploadIssures?.issued_by_id}
            name="issued_by_id"
            onChange={(e) => {
              handleChangeINput(e);
            }}
          >
            {issures?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
          <div className={styles.filecontainer}>
            {/* <div className={styles.uploadcontainer}>
              <p className={styles.name}>Upload Signature</p>
              <UploadImage getImage={setImage} imgs={image} />
              <div style={{ marginTop: "20px" }}>
                {buildingImg.map((item) => {
                  const filename = item.image.split("/").pop();
                  if (item.type !== 2) return;
                  return (
                    <div
                      style={{ background: "#AFDB2826" }}
                      className={styles.imageContainer}
                    >
                      <div>
                        <img
                          src={item.image}
                          style={{ marginRight: "15px", width: "80px" }}
                        />
                      </div>
                      <div>{filename}</div>
                      <div></div>
                    </div>
                  );
                })}
              </div>
            </div> */}
            <p className={styles.fieldName}>
              {language == "de"
                ? consumptionGermText?.reccomendation
                : consumptionEngText?.reccomendation}
            </p>
            <div className={styles.fieldDetailsCon}>
              <CostEffectiveTable
                serial={submitData.serial_number}
                handleData={handleData}
                prevData={submitData?.tableData}
                setFieldError={setFieldError}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            {language == "de"
              ? consumptionGermText?.close
              : consumptionEngText?.close}
          </Button>
          <Button
            variant="contained"
            onClick={() => handleSubmit()}
            autoFocus
            disabled={prevData?.payment_status !== 2}
            sx={{
              "&:disabled": {
                background: "gray",
                color: "#ccc",
              },
            }}
          >
            {language == "de"
              ? consumptionGermText?.generate
              : consumptionEngText?.generate}
          </Button>
        </DialogActions>
      </Dialog>

      {/* <CustomCheckBox label={"Yes, I have checked every entries"} />
      <div className={styles.btns}>
        <Button variant="outlined">Preview</Button>
        <Button variant="contained">Generate Final Certificate</Button>
      </div>
      {open == true && (
        <FinalCertificate open={open} handleClose={handleClose} />
      )} */}
    </div>
  );
}

export default GenerateNeedCertificate;
